/**
 * LocalStorage Keys Constants
 * Centralized location for all localStorage key names used across the application
 */

export const STORAGE_KEYS = {
  SEARCH_RESULTS_CURRENT_TEXT: "searchResults_currentSearchText"
};
